module.exports = __webpack_public_path__ + "img/freezing_rain_heavy.50f3e5e7.svg";